import { Add } from '@tunasong/icons'
import type { TypographyProps } from '../primitives/index.js'
import { Typography } from '../primitives/index.js'
import cn from 'classnames'
import type { FC, MouseEvent } from 'react'
import { IconButton } from '../primitives/index.js'
import styles from './action-header.module.css'

export interface ActionHeaderProps extends TypographyProps {
  className?: string
  title: string
  onAction(event: MouseEvent): void
}

export const ActionHeader: FC<ActionHeaderProps> = props => {
  const { className, title, onAction, children, variant = 'subtitle1', ...restProps } = props

  return (
    <div className={cn(styles.container, className)}>
      <Typography display="inline" variant={variant} {...restProps}>
        {title}
      </Typography>
      {children}
      <IconButton onClick={onAction}>
        <Add />
      </IconButton>
    </div>
  )
}
